import React, { Component } from "react";
import { connect } from "react-redux";
import CustomTable from "../../utils/commonComponent/CustomAntTable";
import { Button, Col, Image, Row } from "react-bootstrap";
import editIcon from '../../assets/images/edit-icon.svg'
import deleteIcon from '../../assets/images/delete-icon.svg'
import { ComponentHeader, InformationModal, VerifiedModal } from "../common";
import { API_LIMIT, MODULE_ID_MAP, START_PAGE, Subscription, isModuleExist, subCoupon } from "../../utils/Constant";
import { deleteSubscriptionApi, getAllSubscriptionApi } from "./Api";
import PremimumPlanForm from "./PremimumPlanForm";
import { PREMIUM_PLAN_VERIFY } from "../../utils/urls";
import editPencil from "../../assets/images/edit-icon.png";
import FilterVefiedDropDown from "../common/FilterVefiedDropDown";
import { withRouter } from "../../utils/hoc/withRouter";
import { Tag } from "antd";
import OptionsDropdown from "../../utils/commonComponent/OptionsDropdown";


export class PremimumPlaneTab extends Component {
  constructor(props) {
    super(props);
    const AccesData = isModuleExist(MODULE_ID_MAP.SubscriptionCoupon);

    this.state = {
      access: AccesData,
      dummyData: [],
      pageSize: API_LIMIT,
      currentPage: START_PAGE,
      languageList: [],
      totalPages: null,
      delete: false,
      deleteData: {},
      editData: "",
      showEdit: false,

      isVerify: false,
      show: false,

      verified: '',
      verifyUrl: ''
    };
  }


  // todo---------------------------------------
  componentDidMount() {
    const { history, access } = this.props;
    history({
      pathname: this.props.location.pathname,
      search: `?p=${this.state.currentPage || START_PAGE}`,
    });
    this.props.getAllSubscriptionApi(this);
  }
  // todo---------------------------------------
  // todo:-----------------------------------------
  componentDidUpdate(prevProps, prevState) {
    const prevParams = new URLSearchParams(prevProps.location.search);
    const prevPage = parseInt(prevParams.get("page"), 10) || START_PAGE;
    const prevVerified = prevParams.get("isVerified") || "";
    const prevSearch = prevParams.get("search") || "";
    const prevSize = prevParams.get("pageSize") || "";
    const params = new URLSearchParams(this.props.location.search);
    const page = parseInt(params.get("page"), 10) || START_PAGE;
    const verified = params.get("isVerified") || "";
    const size = params.get("pageSize") || "";
    const search = params.get("search") || "";
    // const search = params.get("search") || "";

    if (prevPage !== page || prevVerified !== verified || prevSearch !== search || prevSize !== size) {
      this.setState({ currentPage: page }, () => {
        this.props.getAllSubscriptionApi(this);

      });
    }
  }
  // todo:-----------------------------------------

  showEditModal = (rowData = null) => {
    this.setState({
      showEdit: !this.state.showEdit,
      editData: rowData,
    });
  };
  openCloseDeleteModal = (rowData) => {
    this.setState({
      delete: !this.state.delete,
      deleteData: rowData,
    });
  };
  deleteHandle = (id) => {
    //  console.log("yes delete  this id",)
    deleteSubscriptionApi(id, this, this.openCloseDeleteModal)
  }

  getDetailsUser = (id) => {
    this.props.history({ pathname: `/premium-plan-details/${id}`, state: { "id": id } });
  }

  render() {
    const { showEdit, access } = this.state;
    const { listData, totalPages, currentPage } = this.props.masterCategoryState;
    return (
      <section className="request-section">

        {this.state.delete && (
          <InformationModal
            show={this.state.delete}
            id={this.state.deleteData.uuid}
            title={`Are you sure you want to delete  '${this.state.deleteData.name}' Plan ?`}
            handleClose={this.openCloseDeleteModal}
            handleDelete={this.deleteHandle}
          />
        )}

        <VerifiedModal
          name={`'${this.state.editData?.name}'`}
          show={this.state.show}
          url={PREMIUM_PLAN_VERIFY + `/${this.state?.editData?.uuid}`}
          isVerified={this.state.isVerify}
          handleCancel={() => { this.setState({ show: false }) }}
          successRes={() => { this.props.getAllSubscriptionApi(this) }}
        />
        {
          showEdit &&
          <PremimumPlanForm
            show={showEdit}
            onHide={this.showEditModal}
            editData={this.state.editData}
            this={this}
          />
        }
        <ComponentHeader
          title="Premium Plan"
          breadcrumb={[["Subscription", ""], ["Premium Plan", ""]]}
          primaryBtn={access.createAccess ? "Add Plan" : ""}
          handlePrimaryBtn={() => {
            this.props.history('/premimum-planForm');
            // this.setState({showEdit:true})
          }}
          ctx={this}
        />
        <Row>
          <Col sm={2}>
            <FilterVefiedDropDown ctx={this} />
          </Col>
        </Row>
        <div className="commom-table-wrapper">
          <CustomTable
          ctx={this}
            data={listData?.list || []}
            columns={[

              {
                width: 150,
                title: "Plan Name ",
                dataIndex: "name",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.name;
                  }
              },
              {
                width: 150,
                title: "Membership Name",
                dataIndex: "name",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData?.premiumPlan?.name;
                },
              },
              {
                width: access.verificationAccess ? 100 : 0,
                title: "Verified",
                dataIndex: "isVerified",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                 const color = rowData.isVerified ? 'green' : 'orange';
                    return <div className=" d-flex align-items-center inter-medium">
                      <Tag color={color}>{rowData.isVerified ? "YES" : "NO"}
                        <Image src={editPencil} onClick={() => this.setState({ show: true, isVerify: rowData.isVerified, editData: rowData })} className="edit-pencil-icon" alt="icon" />
                      </Tag>
                    </div>;
                },
              },

              {
                width: 130,
                title: "Updated By",
                dataIndex: "updatedBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.updatedBy?.name || 'Na';
                },
              },
              {
                width: 130,
                title: "Created By",
                dataIndex: "createdBy",
                className: "name",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return rowData.createdBy?.name || 'Na';
                },
              },
              // {
              //   width: 140,
              //   title: "",
              //   dataIndex: "",
              //   className: "name",
              //   isCell: true,
              //   render:(text, rowData, dataKey) => {
              //       return (
              //         <Button onClick={() => this.getDetailsUser(rowData?.uuid)} className="primary-btn inter-medium f-s-14 lh-18 mr-5">
              //           View Detail
              //         </Button>
              //       );
              //   },
              // },
              {
                // width: 150,
                width: 20,

                title: "Action",
                dataIndex: "",
                className: "",
                fixed: "right",
                isCell: true,
                render:(text, rowData, dataKey) => {
                    return (
                      // <div className="d-flex gap-4 justify-content-around">

                      //   {access.updateAccess && (
                      //     <Image src={editIcon} className="edit-icon" onClick={() => { this.props.history({ pathname: '/premimum-planForm', state: { editData: rowData } }) }} />
                      //   )}
                      //   {access.deleteAccess && (
                      //     <Image src={deleteIcon} className="edit-icon" onClick={() => { this.openCloseDeleteModal(rowData) }} />
                      //   )}
                      // </div>
                      <OptionsDropdown
                        editHandler={access.updateAccess ? () => { this.props.history({ pathname: '/premimum-planForm', state: { editData: rowData } }) } : null}
                        deleteHandler={access.deleteAccess ? () => { this.openCloseDeleteModal(rowData) } : null}
                        viewHandler={() => this.getDetailsUser(rowData?.uuid)}
                      />
                    );
                  }
                
              },
            ]}
           
            total={listData?.length || 0}
              loading={this.state.isLoading}
          />
        </div>
      </section>
    );
  }
}

const mapStateToProps = (state) => ({
  masterCategoryState: state.MasterCategoryState,
});
const mapDispatchToProps = {
  getAllSubscriptionApi
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PremimumPlaneTab));
